import { render, staticRenderFns } from "./RbacTable.vue?vue&type=template&id=fe213110"
import script from "./RbacTable.vue?vue&type=script&lang=js"
export * from "./RbacTable.vue?vue&type=script&lang=js"
import style0 from "./RbacTable.vue?vue&type=style&index=0&id=fe213110&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports